exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-copy[data-v-378261a2]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#context-menu[data-v-378261a2]{top:0;left:0;margin:0;padding:0;display:none;list-style:none;position:absolute;z-index:2147483647;background-color:#fff;border:thin solid #00654c;border-bottom-width:0}#context-menu.active[data-v-378261a2]{display:block}.close-button[data-v-378261a2]{position:absolute;top:-27px;left:107px}.menu-icon[data-v-378261a2]{width:100%;text-align:left;padding:8px 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-378261a2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Top/ContextMenuScenarioDemo.vue
// module id = X5K4
// module chunks = 0